import React from "react";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { formatDate } from "../../lib/api";

export function trendText(p) {
  const t = p.trend;
  if (!t) return p.tracking_since ? `Tracking since ${formatDate(p.tracking_since)}` : "No history yet";
  const risk = t.risk_delta === 0 ? "Risk unchanged" : `Risk ${t.risk_delta > 0 ? "+" : ""}${t.risk_delta}${t.prev_risk_tier !== p.risk_tier ? ` (${t.prev_risk_tier} → ${p.risk_tier})` : ""}`;
  const s = t.schedule_shift_days;
  const sched = s == null ? "Schedule n/a" : s === 0 ? "Schedule unchanged" : `Schedule ${Math.abs(s)}d ${s > 0 ? "later" : "earlier"}`;
  return `${risk} · ${sched}`;
}

function Delta({ value, label, testId }) {
  const Icon = value > 0 ? ArrowUp : value < 0 ? ArrowDown : Minus;
  const tone = value > 0 ? "text-rose-300" : value < 0 ? "text-emerald-300" : "text-slate-400";
  return <span className={`inline-flex items-center gap-1 ${tone}`} data-testid={testId}><Icon size={11} /> {label}</span>;
}

export default function TrendCell({ p }) {
  const t = p.trend;
  if (!t) {
    return <span className="text-[11px] text-slate-500" data-testid={`exec-trend-${p.id}`}>{trendText(p)}</span>;
  }
  const s = t.schedule_shift_days;
  const title = `Since ${formatDate(t.since_date)}: risk ${t.prev_risk_score} (${t.prev_risk_tier}), calculated delivery ${t.prev_planned_delivery ? formatDate(t.prev_planned_delivery) : "—"}${t.prev_days_late != null ? `, ${t.prev_days_late > 0 ? `${t.prev_days_late}d late` : `${Math.abs(t.prev_days_late)}d ahead`}` : ""}`;
  return (
    <div className="flex flex-col gap-0.5 text-xs whitespace-nowrap" title={title} data-testid={`exec-trend-${p.id}`}>
      <Delta value={t.risk_delta} testId={`exec-trend-risk-${p.id}`}
        label={t.risk_delta === 0 ? "Risk same" : `Risk ${t.risk_delta > 0 ? "+" : ""}${t.risk_delta}${t.prev_risk_tier !== p.risk_tier ? ` (${t.prev_risk_tier} → ${p.risk_tier})` : ""}`} />
      {s == null
        ? <span className="text-slate-500" data-testid={`exec-trend-schedule-${p.id}`}>Schedule n/a</span>
        : <Delta value={s} testId={`exec-trend-schedule-${p.id}`} label={s === 0 ? "Schedule same" : `${Math.abs(s)}d ${s > 0 ? "later" : "earlier"}`} />}
    </div>
  );
}
